// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YY6Z","label":"styles_label__34dv-"};